import { useMutation } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { AxiosError } from 'axios';
import { BaseError, BaseResponse } from '@utils/types/shared/base.ts';
import { MfaCodes } from '@utils/types/users/2fa.ts';

export type Payload = {
  token: string;
};

export const verifyCode = async (
  payload: Payload
): Promise<BaseResponse<MfaCodes>> => {
  const { data } = await Axios.post<BaseResponse<MfaCodes>>(
    POST_URL(payload.token).enable2fa
  );
  return data;
};

export function useEnable2fa() {
  return useMutation<BaseResponse<MfaCodes>, AxiosError<BaseError>, Payload>(
    (payload: Payload) => verifyCode(payload)
  );
}
